export default __webpack_public_path__ + "static/media/logo.f0489f8b.svg";